import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=b2b0089e&"
import script from "./recordList.vue?vue&type=script&lang=js&"
export * from "./recordList.vue?vue&type=script&lang=js&"
import style0 from "./recordList.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports